export default __webpack_public_path__ + "static/media/home-bg-one.3d34eb92.svg";